export interface SpecialPermissions {
    canReassignCS: boolean;
    canUnassignCS: boolean;
    canReassignCL: boolean;
    canUnassignCL: boolean;
    canAddQm: boolean;
    canEditQualificationMapping: boolean;
    canAssignQm: boolean;
    canBulkSetAutMatchSettings: boolean;
    canBulkSetQmAutMatchSettings: boolean;
    canBulkEditACStatus: boolean;
    canEditTravelGlobal: boolean;
    canEditTravelAssociation: boolean;
    canEditLocumsGlobal: boolean;
    canEditLocumsAssociation: boolean;
    canEditAccessControlGlobal: boolean;
    canEditAccessControlAssociation: boolean;
    canEditTravelFacility: boolean;
    canEditLocumsFacility: boolean;
    canEditAccessControlFacility: boolean;
}

export function toSpecialPermissions(value: Partial<SpecialPermissions>): SpecialPermissions {
    return {
        canReassignCL: value?.canReassignCL ?? false,
        canUnassignCL: value?.canUnassignCL ?? false,
        canReassignCS: value?.canReassignCS ?? false,
        canUnassignCS: value?.canUnassignCS ?? false,
        canAddQm: value?.canAddQm ?? false,
        canEditQualificationMapping: value?.canEditQualificationMapping ?? false,
        canAssignQm: value?.canAssignQm ?? false,
        canBulkSetAutMatchSettings: value?.canBulkSetAutMatchSettings ?? false,
        canBulkSetQmAutMatchSettings: value?.canBulkSetQmAutMatchSettings ?? false,
        canBulkEditACStatus: value?.canBulkEditACStatus ?? false,
        canEditTravelGlobal: value?.canEditTravelGlobal ?? false,
        canEditTravelAssociation: value?.canEditTravelAssociation ?? false,
        canEditLocumsGlobal: value?.canEditLocumsGlobal ?? false,
        canEditLocumsAssociation: value?.canEditLocumsAssociation ?? false,
        canEditAccessControlGlobal: value?.canEditAccessControlGlobal ?? false,
        canEditAccessControlAssociation: value?.canEditAccessControlAssociation ?? false,
        canEditTravelFacility: value?.canEditTravelFacility ?? false,
        canEditLocumsFacility: value?.canEditLocumsFacility ?? false,
        canEditAccessControlFacility: value?.canEditAccessControlFacility ?? false
    };
}
